import React, { useMemo } from 'react';
import { View, TouchableOpacity, StyleSheet, Platform, useWindowDimensions } from 'react-native';
import { getResponsiveValue } from '../styles/breakpoints';
import { useTheme } from '../contexts/ThemeContext';

// Helper function to detect mouse support
const hasMouseSupport = () => {
    return Platform.OS === 'web' && window.matchMedia('(pointer: fine)').matches;
};

/**
 * Tile wrapper for library files/cards. Dimensions match MediaManagerStyles.folderTouchable
 * (same heights as folder tiles) and fill folderContainer — folders are the source of truth.
 */
function useLibraryItemTileStyle() {
    const { width } = useWindowDimensions();
    return useMemo(() => {
        const height = getResponsiveValue({
            mobile: 100,
            tablet: 100,
            laptop: 130,
            desktop: 130,
        });
        return {
            width: '100%',
            alignSelf: 'stretch',
            minWidth: 0,
            maxHeight: 200,
            height,
            marginBottom: 0,
            borderRadius: 12,
            overflow: 'hidden',
            borderWidth: 2,
            borderColor: 'transparent',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 3,
        };
    }, [width]);
}

export function ItemWrapper({
    children,
    isSelected,
    onPress,
    onLongPress,
    isDragging = false,
    itemType = 'file'
}) {
    const { theme } = useTheme();
    const selection = theme.text.primary;
    const containerStyle = useLibraryItemTileStyle();
    return (
        <View
            style={[
                containerStyle,
                isSelected && { borderColor: selection, shadowColor: selection, shadowOpacity: 0.3 },
                isDragging && styles.draggingContainer,
            ]}
        >
            <div
                {...(hasMouseSupport() && {
                    onContextMenu: (e) => {
                        e.preventDefault();
                        onLongPress && onLongPress(e);
                    }
                })}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <TouchableOpacity
                    onPress={onPress}
                    onLongPress={onLongPress}
                    style={styles.touchableArea}
                    activeOpacity={0.8}
                >
                    {children}
                </TouchableOpacity>
            </div>
        </View>
    );
}

const styles = StyleSheet.create({
    draggingContainer: {
        opacity: 0.5,
        transform: [{ scale: 0.95 }],
    },
    touchableArea: {
        width: '100%',
        height: '100%',
    },
});
